export function getRedirectionUrl(n){const o=window.location.origin?window.location.origin:"";try{return new URL("/",o).toString()}catch{return n(o)}}